/**
 * Lightweight, layout-reserving skeleton for lazy-loaded landing sections.
 * Does NOT shift content — reserves vertical space matching the real section.
 */
export const SectionSkeleton = ({ height = 'h-96', testId = 'section-skeleton' }) => (
  <div className={`w-full ${height} animate-pulse`} data-testid={testId} aria-busy="true">
    <div className="max-w-6xl mx-auto px-6 py-12 md:py-16">
      <div className="h-6 w-40 bg-surface_muted rounded mx-auto mb-8" />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {[0, 1, 2, 3, 4].map((i) => (
          <div key={i} className="border border-border bg-white rounded-xl overflow-hidden">
            <div className="aspect-[4/3] bg-surface_muted" />
            <div className="p-4 space-y-2">
              <div className="h-4 w-3/4 bg-surface_muted rounded" />
              <div className="h-3 w-1/2 bg-surface_muted rounded" />
              <div className="h-5 w-1/3 bg-surface_muted rounded" />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);
